<section id="faq" class="section section-light">
	<div class="container faq-wrap">
		<h2>Preguntas frecuentes</h2>

		<details>
			<summary>¿Qué incluye el primer mes gratis?</summary>
			<p>Incluye acceso al plan elegido para que puedas probar la plataforma en un entorno real de trabajo y
				evaluar cómo se adapta a tu negocio.</p>
		</details>
		<details>
			<summary>¿NETiC sirve solo para servicios técnicos?</summary>
			<p>No. NETiC está pensado para distintos tipos de negocio que necesitan ordenar su gestión, centralizar
				información y trabajar de forma más digital y profesional.</p>
		</details>
		<details>
			<summary>¿Necesito instalar algo en mis computadoras?</summary>
			<p>No. Al ser una plataforma en la nube, podés acceder desde el navegador con tu usuario y contraseña, sin
				instalaciones complejas.</p>
		</details>
		<details>
			<summary>¿Puedo cambiar de plan más adelante?</summary>
			<p>Sí. Podés cambiar de plan según las necesidades de tu negocio a medida que tu operación crece o cambia.
			</p>
		</details>
		<details>
			<summary>¿Mis datos están protegidos?</summary>
			<p>Sí. La plataforma está preparada para resguardar la información de cada empresa y ofrecer un acceso
				seguro para sus usuarios.</p>
		</details>
	</div>
</section>